import React, { useEffect, useState } from "react";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import HttpService from "../../services/httpService";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TableContainer,
    makeStyles
} from "@material-ui/core";
import { FormControl, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import { Modal } from "antd";
import { Button as AntdButton } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import Button from "@material-ui/core/Button";
import DownloadIcon from "@material-ui/icons/GetApp";
import { useRef } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const useStyles = makeStyles(() => ({
    container: {
        maxHeight: 500,
        overflow: "auto"
    },

    tableHead: {
        backgroundColor: "#3f51b5"
    },

    headCell: {
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center",
        position: "sticky",
        top: 0,
        backgroundColor: "#3f51b5",
        zIndex: 3
    },

    monthHeaderCell: {
        left: 0,
        zIndex: 4
    },

    monthCell: {
        fontWeight: "bold",
        backgroundColor: "#f4f6fb",
        position: "sticky",
        left: 0,
        zIndex: 2
    },

    clickableCell: {
        color: "#3f51b5",
        fontWeight: 600,
        textDecoration: "underline",
        cursor: "pointer",
        textAlign: "center",
        "&:hover": {
            backgroundColor: "#eef1ff"
        }
    }
}));

const WhatsAppDashboard = (props) => {
    const classes = useStyles();

    const campaignsArrays = [
        { name: "Marketing Disqualified Forms - BotWot" },
        { name: "Move to Marketing - BotWot" },
        { name: "Channel Partner Leads - BotWot" },
        { name: "Lost" },
        { name: "Requirement Not Collected" },
        { name: "Overall Data" }
    ];


    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCell, setSelectedCell] = useState(null);
    const [storeDateFilter, setPivotDateFilters] = useState({ startDate: "", endDate: "" })
    const [sources, setSources] = useState(campaignsArrays)
    const [selectedCampaign, setSelectedCampaign] = useState([])
    const [dataPopup, setDataPopup] = useState([]);
    const [popupMeta, setPopupMeta] = useState({
        stage: "",
        month: ""
    });

    const csvButtonRef = useRef(null);
    const [mainTableCsvData, setMainTableCsvData] = useState([]);
    const mainTableCsvButtonRef = useRef(null);

    const headers = [
        { label: "Lead No", key: "leadNo" },
        { label: "Client Name", key: "clientName" },
        { label: "Created At", key: "createdAt" },
        { label: "Source Of Lead", key: "sourceOfLead" },
        { label: "City", key: "city" },
        { label: "Experience Center", key: "experienceCenter" },
        { label: "Current Stage", key: "currentStage" },
        { label: "Department", key: "department" },
    ];

    const csvData = dataPopup.map((lead) => ({
        leadNo: lead.lead_no || "-",
        clientName: lead.customerId?.name || "-",
        createdAt: lead.createdAt
            ? new Date(lead.createdAt).toLocaleDateString()
            : "-",
        sourceOfLead: lead.sourceOfLead?.name || "-",
        city: lead.city?.name || "-",
        experienceCenter: lead.experienceCenterId?.name || "-",
        currentStage: lead.currentStage || "-",
        department: lead.departmentId?.name || "-",
    }));

    const csvDownloadHandler = () => {
        if (!dataPopup.length) return;
        csvButtonRef.current.link.click();
    };

    // Function to generate CSV data for main WhatsApp Campaign Dashboard table
    const generateMainTableCsv = () => {
        try {
            if (!data || data.length === 0) {
                setMainTableCsvData([]);
                return;
            }

            const csvRows = data.map((item) => {
                const row = {};
                row["Month"] = item.month || "";
                row["Total Disqualified"] = item?.totalDisqualified?.count || 0;
                row["WhatsApp Yes (Reactivated)"] = item?.whatsappYes?.count || 0;
                row["BotWot No"] = item?.botwotNo?.count || 0;
                row["No Response"] = item?.noResponse?.count || 0;
                row["Moved to Call Center"] = item?.movedToCallCenter?.count || 0;
                row["Reactivation from Call Center"] = item?.reactivationFromCallCenter?.count || 0;
                row["Total Reactivation"] = item?.totalReactivation?.count || 0;
                return row;
            });

            setMainTableCsvData(csvRows);
        } catch (error) {
            console.error("Error generating main table CSV:", error);
            props?.setSnackInfo("Error generating main table CSV", "error");
        }
    };

    useEffect(() => {
        whatsAppCampaign();
    }, []);

    // Generate CSV data when data changes
    useEffect(() => {
        if (data && data.length > 0) {
            generateMainTableCsv();
        }
    }, [data]);

    const whatsAppCampaign = async (addCampaigns) => {
        let campaignsData = addCampaigns?.map((el) => el.name)
        try {
            let obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedCampaigns: campaignsData ? campaignsData : "",
            }
            setLoading(true);
            const response = await HttpService.whatsAppCampaignDashboard(obj);
            setData(response?.data?.data || []);
        } catch (error) {
            console.error("Dashboard Error", error);
        } finally {
            setLoading(false);
        }
    };

    const getDataWhatsAppDashboard = async ({ stage, month, campaigns }) => {
        let campaignsData = campaigns?.map((el) => el.name);

        try {
            setLoading(true);

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedCampaigns: campaignsData || "",
                stage,
                month
            };

            const response = await HttpService.whatsAppCampaignData(obj);

            setDataPopup(response?.data?.data || []);
            setPopupMeta({ stage, month });
            setModalOpen(true);

        } catch (error) {
            console.error("Lead lifecycle data error", error);
        } finally {
            setLoading(false);
        }
    };



    // const getSourceOfLeads = async () => {
    //     try {
    //         const response = await HttpService.getLeadMaster()
    //         setSources(response.data)
    //     } catch (error) {
    //         console.error(
    //             "Error fetching source of leads:",
    //             error?.response?.data || error.message
    //         );
    //     }
    // };

    const handleCellClick = (month, stage, stageData) => {
        if (loading) return;

        setSelectedCell({
            month,
            stage,
            count: stageData?.count || 0,
            leads: stageData?.leads || []
        });
        setModalOpen(true);
    };
    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDateFilters({ ...storeDateFilter, [name]: value })
    }

    const handleMultipleCampaigns = (event, newValue) => {
        setSelectedCampaign(newValue)
        handleCampaign(newValue)
    }

    const handleCampaign = async (newValue) => {
        props.setLoading(true);
        await whatsAppCampaign(newValue)
        props.setLoading(false);
    }

    const renderCell = (item, stageKey) => (
        <TableCell
            className={classes.clickableCell}
            onClick={() =>
                getDataWhatsAppDashboard({
                    stage: stageKey,
                    month: item.month,
                    campaigns: selectedCampaign
                })
            }
        >
            {item?.[stageKey]?.count ?? 0}
        </TableCell>
    );

    const renderSkeletonRows = () =>
        Array.from({ length: 6 }).map((_, index) => (
            <TableRow key={index}>
                {/* Month */}
                <TableCell className={classes.monthCell}>
                    <Skeleton width={80} />
                </TableCell>

                {/* Other columns */}
                {Array.from({ length: 7 }).map((_, i) => (
                    <TableCell key={i} align="center">
                        <Skeleton width={30} />
                    </TableCell>
                ))}
            </TableRow>
        ));

    return (
        <>
            <h1>WhatsApp Campaign Dashboard</h1>
            <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                style={{ marginBottom: "1rem" }}
            >
                <Grid item xs={12} sm={4} md={3}>
                    <FormControl fullWidth>
                        <Autocomplete
                            multiple
                            value={selectedCampaign}
                            onChange={handleMultipleCampaigns}
                            options={sources}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Filter By Campaign"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                {/* Hidden CSV Link */}
                <CSVLink
                    data={mainTableCsvData}
                    filename={`WhatsApp_Campaign_Dashboard_${moment().format(
                        "YYYY-MM-DD"
                    )}.csv`}
                    ref={mainTableCsvButtonRef}
                    style={{ textDecoration: "none", display: "none" }}
                />

                {/* Download CSV Button */}
                <AntdButton
                    style={{
                        backgroundColor: "#355025",
                        color: "#FFF2EB",
                        marginBottom: "6px",
                    }}
                    icon={<DownloadOutlined />}
                    onClick={() => {
                        generateMainTableCsv();
                        setTimeout(() => {
                            if (
                                mainTableCsvButtonRef.current &&
                                mainTableCsvData.length > 0
                            ) {
                                mainTableCsvButtonRef.current.link.click();
                            }
                        }, 200);
                    }}
                >
                    Download CSV
                </AntdButton>
            </div>
            <TableContainer component={Paper} className={classes.container}>
                <Table stickyHeader>
                    {/* HEADER */}
                    <TableHead>
                        <TableRow>
                            <TableCell
                                className={`${classes.headCell} ${classes.monthHeaderCell}`}
                            >
                                Month
                            </TableCell>
                            <TableCell className={classes.headCell}>Total Disqualified</TableCell>
                            <TableCell className={classes.headCell}>WhatsApp Yes (Reactivated)</TableCell>
                            <TableCell className={classes.headCell}>BotWot No</TableCell>
                            <TableCell className={classes.headCell}>No Response</TableCell>
                            <TableCell className={classes.headCell}>Moved to Call Center</TableCell>
                            <TableCell className={classes.headCell}>Reactivation from Call Center</TableCell>
                            <TableCell className={classes.headCell}>Total Reactivation</TableCell>
                            {/* <TableCell className={classes.headCell}>Reactivation %</TableCell> */}
                        </TableRow>
                    </TableHead>

                    {/* BODY */}
                    <TableBody>
                        {loading
                            ? renderSkeletonRows()
                            : data.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell className={classes.monthCell}>
                                        {item.month}
                                    </TableCell>
                                    {renderCell(item, "totalDisqualified")}
                                    {renderCell(item, "whatsappYes")}
                                    {renderCell(item, "botwotNo")}
                                    {renderCell(item, "noResponse")}
                                    {renderCell(item, "movedToCallCenter")}
                                    {renderCell(item, "reactivationFromCallCenter")}
                                    {renderCell(item, "totalReactivation")}
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* MODAL */}
            <Modal
                centered
                width={1000}
                maskClosable={true}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <strong>
                                    {popupMeta.stage} – {popupMeta.month}
                                </strong>
                            </Grid>

                            <Grid item>
                                <CSVLink
                                    headers={headers}
                                    filename={`lead_lifecycle_${popupMeta.stage}_${popupMeta.month}.csv`}
                                    data={csvData}
                                    ref={csvButtonRef}
                                />

                                <Button
                                    onClick={csvDownloadHandler}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<DownloadIcon />}
                                >
                                    Download CSV
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                }
            >
                <p style={{ marginBottom: 12 }}>
                    <strong>Total Count:</strong> {dataPopup.length}
                </p>

                {dataPopup.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow style={{ backgroundColor: "#f4f6fb" }}>
                                    <TableCell><strong>SL</strong></TableCell>
                                    <TableCell><strong>Lead No</strong></TableCell>
                                    <TableCell><strong>Client Name</strong></TableCell>
                                    <TableCell><strong>Created At</strong></TableCell>
                                    <TableCell><strong>Source of Lead</strong></TableCell>
                                    <TableCell><strong>City</strong></TableCell>
                                    <TableCell><strong>Experience Center</strong></TableCell>
                                    <TableCell><strong>Current Stage</strong></TableCell>
                                    <TableCell><strong>Department</strong></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {dataPopup.map((lead, index) => (
                                    <TableRow key={lead._id || index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            {lead?.lead_no ? (
                                                <Link
                                                    to={`/project-logs/${lead?._id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: "#1C375D",
                                                        textDecoration: "underline",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {lead.lead_no}
                                                </Link>
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>
                                        <TableCell>{lead.customerId?.name || "-"}</TableCell>
                                        <TableCell>{moment(lead?.createdAt).format("DD-MM-YYYY") || "-"}</TableCell>
                                        <TableCell>{lead.sourceOfLead?.name || "-"}</TableCell>
                                        <TableCell>{lead.city?.name || "-"}</TableCell>
                                        <TableCell>{lead.experienceCenterId?.name || "-"}</TableCell>
                                        <TableCell>{lead.currentStage || "-"}</TableCell>
                                        <TableCell>{lead.departmentId?.name || "-"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <p style={{ color: "#999", textAlign: "center" }}>
                        No leads available
                    </p>
                )}
            </Modal>
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(WhatsAppDashboard);
